import { ComponentsOverrides, Theme } from '@mui/material';

import { muiPalette } from '@/shared/general-theme';

export const InputBaseStyles: ComponentsOverrides<Theme>['MuiInputBase'] =
  {
    root: {
      backgroundColor: 'white',
      borderRadius: '0.375rem',
    },
  };

export const OutlinedInputStyles = (palette: typeof muiPalette): ComponentsOverrides<Theme>['MuiOutlinedInput'] =>
  (
    {
      root: {
        borderRadius: 6,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.border.default,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: palette.primary.main,
        },
      },
    }
  );